import React from "react";
import { useStock } from "../App";

const Icons = {
  Menu: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
};

export default function Topbar({ active, toggleSidebar }) {
  const { profile } = useStock(); 

  const getSubtitle = (page) => {
    switch(page) {
      case "Sales":     return "Manage your daily sales";
      case "Products":  return "Manage your catalog";
      case "Customers": return "Customer directory";
      case "Stock":     return "Inventory management";
      case "Reports":   return "Financial analytics";
      case "Settings":  return "Account preferences";
      default:          return "Overview";
    }
  };

  return (
    <div className="topbar-padding" style={{
      display: "flex", justifyContent: "space-between", alignItems: "center",
      margin: "16px 32px", padding: "16px 24px", 
      background: "#FFFFFF", 
      borderRadius: "16px",
      boxShadow: "0 4px 25px rgba(0,0,0,0.04)",
      border: "1px solid #f1f5f9", 
      position: "sticky", top: "16px", zIndex: 30,
    }}>
      
      {/* Left Side: Menu + Title */}
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        <button className="mobile-show" onClick={toggleSidebar} style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "8px", color: "#0B47B3", cursor: "pointer", padding: "6px", display: "flex", alignItems: "center" }}>
          {Icons.Menu}
        </button>

        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: "#0f172a", letterSpacing: "-0.5px" }}>{active}</h1>
          <p className="mobile-hide" style={{ margin: "2px 0 0", fontSize: 12, color: "#64748b", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>{getSubtitle(active)}</p>
        </div>
      </div>

      {/* Right Side: Profile */}
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>

        <div className="mobile-hide" style={{ display: "flex", alignItems: "center", gap: 12, cursor: "pointer" }}>
          <div style={{ textAlign: "right" }}>
            <p style={{ margin: 0, fontSize: 14, fontWeight: 800, color: "#0f172a" }}>{profile?.name || "Admin"}</p>
            <p style={{ margin: "2px 0 0", fontSize: 12, color: "#0B47B3", fontWeight: 600 }}>{profile?.role || "Administrator"}</p>
          </div>
        </div>
        
        {/* Avatar updated to Brand Color */}
        <div style={{ width: 44, height: 44, borderRadius: 14, background: "#0B47B3", color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, fontWeight: 800, boxShadow: "0 4px 10px rgba(11, 71, 179, 0.3)" }}>
          {profile?.name ? profile.name.charAt(0).toUpperCase() : "C"}
        </div>

      </div>
    </div>
  );
}